import Transaction from './models/Transaction';

const TTL_MS = 60 * 60 * 1000;

function getTransactionFingerprint() {
  return Transaction.findAll()
    .map((txn) => (
      `${txn.id}|${txn.date}|${txn.stockTicker}|${txn.purchasePrice}|${txn.numberOfShares}`
    ))
    .sort()
    .join(';');
}

class PortfolioDataCache {
  _entries = {};

  _isValid(entry) {
    if (!entry) {
      return false;
    }

    if (entry.fingerprint !== getTransactionFingerprint()) {
      return false;
    }

    return Date.now() - entry.timestamp < TTL_MS;
  }

  get(key) {
    const entry = this._entries[key];
    if (!this._isValid(entry)) {
      return null;
    }

    return entry.data;
  }

  set(key, data) {
    this._entries[key] = {
      fingerprint: getTransactionFingerprint(),
      data,
      timestamp: Date.now()
    };
  }

  clear() {
    this._entries = {};
  }
}

export default new PortfolioDataCache();
